import { Endpoints } from '@brg/api'
import {AdaptiveCardWrapper, Colors, useBreakpoint, useIsMobile} from '@brg/ui'
import { FC, useMemo } from 'react'
import { LeftGridText, RightGridText, SummaryTableInfo, SummaryInfoGrid, SummaryTextContainer, CalendarCards, CheckoutCardWrapper, GridTextRow, CardsExpand, CopySuccessTableValues, CopySuccessTableValue } from './styles'
import { ScrollableSlideNavigationItems } from 'shared/components/slideNavigation/ScrollableSlideNavigationItems'
import { useTranslation } from 'react-i18next'
import styled from "styled-components";
import { getCardNumber } from 'shared/helpers/utils/getCardNumber'
import { useSelector } from 'react-redux'
import { selectorOrder } from '../../slices/OrderSlice'
import {LayoutConst} from "../../../../../core";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

export const CheckboxWrapper = styled.div`
    > div {
        > div > div {
            background: transparent;
            border-radius: 3px;
            border: 1px solid ${Colors.galBlack47} !important;
            width: 24px;
            height: 24px;
            svg {
                path {
                    fill: ${Colors.galBlack100};
                }
            }
        }
        div:nth-child(2) {
            color: ${Colors.galBlack47};
        }
    }
`

interface SummaryTableProps {
  marginBottom?: string
  paymentSuccess?: boolean
  info: { [key: string]: string }
  product?: any
  cardsToBuy?: any[]
  isCard?: boolean
}

export const SummaryTable: FC<SummaryTableProps> = ({ product, paymentSuccess, info, marginBottom, cardsToBuy, isCard }) => {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const order: any = useSelector(selectorOrder)
  const is1440BP = useBreakpoint(LayoutConst.screen.mac13)
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);
  const isNotLargeScreen = useMemo(() => (is1440BP || smHeight), [is1440BP, smHeight])  

  return (
      <SummaryTableInfo className='summaryTableINfo' mobile={isMobile} mb={marginBottom}>
        <SummaryTextContainer>
          <SummaryInfoGrid>
            {Object.entries(info).map(entry =>
                <GridTextRow key={entry[0]}>
                  <LeftGridText>{entry[0]}</LeftGridText>
                  <RightGridText>{entry[1] || '-'}</RightGridText>
                </GridTextRow>
            )
            }
            {cardsToBuy?.length ?
                <>
                  <GridTextRow>
                    <LeftGridText>
                      <CardsExpand>
                        <span>{t(`included_fee`)}</span>
                      </CardsExpand>
                    </LeftGridText>
                    <RightGridText>{cardsToBuy.length} {t('reproductions')}</RightGridText>
                  </GridTextRow>
                  {<ScrollableSlideNavigationItems paymentSuccess={paymentSuccess} isDesigner overflowX isPayment>
                    <CalendarCards>
                      {cardsToBuy.map((card: any) => {
                        const cardTemplate = card?.templateType
                        const img = card.images[card.images.length - 1]
                        return <CheckoutCardWrapper
                            isHorizontal={cardTemplate?.orientation === 'horizontal'}
                            height={isNotLargeScreen ? 80 : 100}
                        >
                          <AdaptiveCardWrapper
                              cardProps={{
                                data: {...card,
                                  number: getCardNumber(cardTemplate?.sequenceItem?.number)
                                },
                                templateType: cardTemplate?.nameComponent,
                                appName: 'gallllery',
                                contextName: '365'
                              }}
                              images={card.images}
                              Endpoints={Endpoints}
                          >
                            <CardComponent.MasterCard/>
                          </AdaptiveCardWrapper>
                        </CheckoutCardWrapper>
                      })}
                    </CalendarCards>
                  </ScrollableSlideNavigationItems>}
                </>
                :
                <></>
            }
          </SummaryInfoGrid>
        </SummaryTextContainer>
      </SummaryTableInfo>
  )
}
import { Endpoints } from '@brg/api'
import {AdaptiveCardWrapper, Colors, useBreakpoint, useIsMobile} from '@brg/ui'
import { FC, useMemo } from 'react'
import { LeftGridText, RightGridText, SummaryTableInfo, SummaryInfoGrid, SummaryTextContainer, CalendarCards, CheckoutCardWrapper, GridTextRow, CardsExpand, CopySuccessTableValues, CopySuccessTableValue } from './styles'
import { ScrollableSlideNavigationItems } from 'shared/components/slideNavigation/ScrollableSlideNavigationItems'
import { useTranslation } from 'react-i18next'
import styled from "styled-components";
import { getCardNumber } from 'shared/helpers/utils/getCardNumber'
import { useSelector } from 'react-redux'
import { selectorOrder } from '../../slices/OrderSlice'
import {LayoutConst} from "../../../../../core";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

export const CheckboxWrapper = styled.div`
    > div {
        > div > div {
            background: transparent;
            border-radius: 3px;
            border: 1px solid ${Colors.galBlack47} !important;
            width: 24px;
            height: 24px;
            svg {
                path {
                    fill: ${Colors.galBlack100};
                }
            }
        }
        div:nth-child(2) {
            color: ${Colors.galBlack47};
        }
    }
`

interface SummaryTableProps {
  marginBottom?: string
  paymentSuccess?: boolean
  info: { [key: string]: string }
  product?: any
  cardsToBuy?: any[]
  isCard?: boolean
}

export const SummaryTable: FC<SummaryTableProps> = ({ product, paymentSuccess, info, marginBottom, cardsToBuy, isCard }) => {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const order: any = useSelector(selectorOrder)
  const is1440BP = useBreakpoint(LayoutConst.screen.mac13)
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);
  const isNotLargeScreen = useMemo(() => (is1440BP || smHeight), [is1440BP, smHeight])  

  return (
      <SummaryTableInfo className='summaryTableINfo' mobile={isMobile} mb={marginBottom}>
        <SummaryTextContainer>
          <SummaryInfoGrid>
            {Object.entries(info).map(entry =>
                <GridTextRow key={entry[0]}>
                  <LeftGridText>{entry[0]}</LeftGridText>
                  <RightGridText>{entry[1] || '-'}</RightGridText>
                </GridTextRow>
            )
            }
            {cardsToBuy?.length ?
                <>
                  <GridTextRow>
                    <LeftGridText>
                      <CardsExpand>
                        <span>{t(`included_fee`)}</span>
                      </CardsExpand>
                    </LeftGridText>
                    <RightGridText>{cardsToBuy.length} {t('reproductions')}</RightGridText>
                  </GridTextRow>
                  {<ScrollableSlideNavigationItems paymentSuccess={paymentSuccess} isDesigner overflowX isPayment>
                    <CalendarCards>
                      {cardsToBuy.map((card: any) => {
                        const cardTemplate = card?.templateType
                        const img = card.images[card.images.length - 1]
                        return <CheckoutCardWrapper
                            isHorizontal={cardTemplate?.orientation === 'horizontal'}
                            height={isNotLargeScreen ? 80 : 100}
                        >
                          <AdaptiveCardWrapper
                              cardProps={{
                                data: {...card,
                                  number: getCardNumber(cardTemplate?.sequenceItem?.number)
                                },
                                templateType: cardTemplate?.nameComponent,
                                appName: 'gallllery',
                                contextName: '365'
                              }}
                              images={card.images}
                              Endpoints={Endpoints}
                          >
                            <CardComponent.MasterCard/>
                          </AdaptiveCardWrapper>
                        </CheckoutCardWrapper>
                      })}
                    </CalendarCards>
                  </ScrollableSlideNavigationItems>}
                </>
                :
                <></>
            }
          </SummaryInfoGrid>
        </SummaryTextContainer>
      </SummaryTableInfo>
  )
}
